<div class="tal-center-page">
  <h1>Connettiti ad un server</h1>
  <div class="tal-center-form">
    <div class="tal-form-input">
      <label for="serverurl">Server Url</label>
      <input name="serverurl" input type="text" pInputText placeholder="https://..." />
    </div>
    <p class="tal-error">
      <i class="pi pi-times-circle"></i>
      <span>Questo è un errore</span>
    </p>
    <button  pButton>Connetti</button>
  </div>

</div>
